import React, { useMemo } from 'react'
import { useDepartments } from 'src/components/async/Department/useDepartments'
import { FilterName, FilterParam } from '../FilterBar.types'
import { NONE_VALUE } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'
import { DropdownItemType } from './FilterDropdown.constants'

export const DepartmentFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const departments = useDepartments()
    const filterValues = useMemo<DropdownItemType[]>(
      () => [
        NONE_VALUE,
        ...(departments ?? []).map((department) => ({
          value: department.getModelId(),
          label: department.getName(),
        })),
      ],
      [departments],
    )

    return (
      <FilterDropdown
        filterParam={FilterParam.DEPARTMENT}
        filterName={FilterName.DEPARTMENT}
        filterValues={filterValues}
        isLoading={!departments}
        isNested={isNested}
      />
    )
  },
)
